import { render, staticRenderFns } from "./AdsTxt.vue?vue&type=template&id=38434427"
import script from "./AdsTxt.vue?vue&type=script&lang=ts"
export * from "./AdsTxt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports